import React from "react";
import { IOrgConfig } from "../../../models/currentUser/OrgConfig";
import { observer } from "mobx-react";
import { MetricsPreviewSettings } from "./metricsPreviewSettings";
import { SlaSettings } from "./slaSettings";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { AppPermission } from "@closerplatform/spinner-openapi";

interface Props {
  orgConfig: IOrgConfig;
}

export const ReportsSettings = withPermissionFallback(
  AppPermission.SettingsGeneral,
  observer(({ orgConfig }: Props) => {
    return (
      <>
        <MetricsPreviewSettings orgConfig={orgConfig} />

        <SlaSettings orgConfig={orgConfig} />
      </>
    );
  })
);
